module.exports = __webpack_public_path__ + "img/aa2dd8a.jpg";